<template>
  <div class="right">
    <threecategory @initData="initData"></threecategory>
    <div class="live topprograss">
    	<div class="flex">
    		<div class="left flex1">
    			<div class="top">
    				<span style="margin-right: 15px;width: 70PX;">做题进度</span>
    				<div class="prograss">
    					<span class="rato"  :style="'width: '+data.alreadyQuestionCount/data.totalQuestionCount*100+'%'"></span>
    				</div>
    				<span class="done">已做：{{data.alreadyQuestionCount}}</span>/ 总数：{{data.totalQuestionCount}}
    			</div>
    			<div class="bottom" style="margin-top: 30px;">
    				<span style="margin-right: 15px;width: 70PX;">正确率</span>
    				<div class="prograss">
    					<span class="rato"  :style="'width: '+data.answerRatio+'%'"></span>
    				</div>
    				正确率：
    				<span class="done">{{data.answerRatio||'0%'}}</span>
    			</div>
    		</div>
    	<!-- 	<div class="btn">
    			开始练习
    		</div> -->
    	</div>
    </div>
    <div class="live">
    	<div class="title">
    		{{title}}
    	</div>
    	<div class="lists">
    		<div class="list" v-for="item in list">
    			<span class="childNames">{{item.title}}</span>
    			<div class="prograss">
    				<!-- <span class="rato"  style="width: 60%;"></span> -->
    			</div>
    			<!-- <span class="done">{{item.peopleCount}}人做过</span> | 共{{item.totalQuestionsCount}} -->
    			<div class="viewWrap">
    				<span class="view" @click="handleToTest(item.testQuestionsId,item.totalQuestionsCount,item.questionsStatus)" v-if="isbuy">答题</span>
            <span class="view" @click="handleToBuy()" v-else>购买</span>
    			</div>
    		</div>
    	</div>

    </div>
  </div>
</template>

<script>
  import threecategory from './threecategory.vue'
  import bus from '../assets/utils/eventBus.js';
  export default {
    name: 'Footer',
    components:{
      threecategory
    },
    props:{
      title:{
          type:String,
          default:()=>''
      },
      list:{
        type:Array,
        default:()=>[]
      },
      questionsStatus:{
        type:Number,
        default:()=>''
      }
    },
    data () {
      return {
          data:'',
          isbuy:this.$store.state.isbuy
      }
    },
    methods:{
      getTestData(testQuestionsId,questionsStatus){ //获取数据
      var url=this.$common.testPaper_testPaperQuestionList;
      	if(this.questionsStatus>2){

      		url=this.$common.testPaper_selectTestQuestionListByPageSize
      	}
        let data={
          pageNo:1,
          pageSize:1000,
          testQuestionsId:testQuestionsId
        };
        this.$axios.get(url,{params:data}).then((res)=>{

        })
      },
      handleToBuy(){
        this.$router.push('buy')
      },
      handleToTest(testQuestionsId,totalQuestionsCount,questionsStatus){
        if(totalQuestionsCount==0){
          alert('上题中');
          return;
        }
        this.getTestData(testQuestionsId,questionsStatus)
        this.$router.push('examsdetail?questionsStatus='+this.questionsStatus+'&testQuestionsId='+testQuestionsId)
      },
      getData(){
        this.$axios.get(this.$common.testPaper_selectQuestionsCountByAccountId+'?childQuestionStatus='+this.questionsStatus).then((res)=>{
              if(res.data.code==1){
                  this.data=res.data.data;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      initData(){
        this.getData();
        this.$emit('initData')
      }
    },
    created(){
      this.getData();
      
    },
    mounted() {
      bus.$on('bugTag',(res)=>{
          this.isbuy=res;
      })
    }
  }
</script>

<style scoped>
  .live {
    border: none;
  }
  .live .list {

      padding-left: 0;

  }
  .live .list .childNames {
    font-weight: bold;
    flex:1;
  }
  .topprograss {
    background-color: #fff;
    border: 1px solid silver;
  }
  .live .lists {
    background-color: #fff;
    border: 1px solid silver;
    border-top: none;

  }
  .live .title, .messageList .title {
      border: 1px solid silver;
      margin-top: 15px;
      border-bottom: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/monilist.vue